import React, { useEffect, useRef, useState } from "react";
import "./Image.css";
import { LazyLoadImage } from "react-lazy-load-image-component";
import "react-lazy-load-image-component/src/effects/blur.css";

const Image = ({ imgUrl, alt = "image" }) => {
    const imageWrapperRef = useRef(null);
    const openedFromHistoryRef = useRef(false);

    const [isOpen, setIsOpen] = useState(false);
    const [isLoaded, setIsLoaded] = useState(false);
    const [isFullscreenLoaded, setIsFullscreenLoaded] = useState(false);

    useEffect(() => {
        setIsLoaded(false);
        setIsFullscreenLoaded(false);
    }, [imgUrl]);

    const openFullscreen = () => {
        setIsOpen(true);

        if (!openedFromHistoryRef.current) {
            window.history.pushState({ imageFullscreen: true }, "");
            openedFromHistoryRef.current = true;
        }
    };

    const closeFullscreen = (e, fromPopState = false) => {
        if (e) e.stopPropagation();

        setIsOpen(false);

        if (!fromPopState && openedFromHistoryRef.current) {
            openedFromHistoryRef.current = false;
            window.history.back();
        }
    };

    useEffect(() => {
        const handlePopState = () => {
            if (isOpen) {
                openedFromHistoryRef.current = false;
                setIsOpen(false);
            }
        };

        window.addEventListener("popstate", handlePopState);
        return () => {
            window.removeEventListener("popstate", handlePopState);
        };
    }, [isOpen]);

    return (
        <>
            <div
                className={`Image ${isLoaded ? "is-loaded" : "is-loading"}`}
                onClick={openFullscreen}
            >
                {!isLoaded && <div className="image-shimmer" />}

                <LazyLoadImage
                    src={imgUrl}
                    alt={alt}
                    effect="blur"
                    threshold={0}
                    loading="lazy"
                    onLoad={() => setIsLoaded(true)}
                    wrapperClassName="image-lazy-wrapper"
                    className={`image-lazy-img ${isLoaded ? "loaded" : "loading"}`}
                />
            </div>

            {isOpen && (
                <div
                    ref={imageWrapperRef}
                    className="image-fullscreen"
                    onClick={(e) => closeFullscreen(e)}
                >
                    {!isFullscreenLoaded && <div className="image-fullscreen-shimmer" />}

                    <button
                        className="image-close"
                        type="button"
                        onClick={(e) => closeFullscreen(e)}
                    >
                        ×
                    </button>

                    <img
                        src={imgUrl}
                        alt={alt}
                        loading="lazy"
                        className={`image-fullscreen-img ${
                            isFullscreenLoaded ? "loaded" : "loading"
                        }`}
                        onLoad={() => setIsFullscreenLoaded(true)}
                    />
                </div>
            )}
        </>
    );
};

export default Image;